module.exports = __webpack_public_path__ + "files/03c4e4d529c59db665d098100e4604a4.png";